import React, { FC } from 'react';
import { useTheme } from '@mui/material';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';

import { IPunchDTO } from 'src/api/dtos';
import { DATE_TIME_FORMAT } from 'src/shared/constants';
import { PunchFunctionEnums } from 'src/shared/enums/punchFunction.enums';
import { useTranslate } from 'src/shared/providers';
import { formatCalendar, formatTime } from 'src/shared/utils';
import { getTimeFormat } from 'src/store/user/user.selectors';
import './PunchItem.styles.scss';

interface Props {
  punch: IPunchDTO;
}

export const PunchItem: FC<Props> = ({ punch }) => {
  const { t } = useTranslate();
  const theme = useTheme();
  const timeFormat = useSelector(getTimeFormat);

  const formattedCalendar = formatCalendar({ today: t('global.today'), yesterday: t('global.yesterday') });

  const { punchTimestamp, punchType, value } = punch;
  const valueSplit: string[] = value ? value.split(';') : [];

  const date = moment(punchTimestamp).calendar(null, formattedCalendar);
  const time = formatTime(punchTimestamp, timeFormat, DATE_TIME_FORMAT);
  const currentPunchTime = `${date}, ${time}`;

  const punchTypeClass = punchType === PunchFunctionEnums.IN ? 'in' : 'out';

  return (
    <>
      {punchType === PunchFunctionEnums.JOB || punchType === PunchFunctionEnums.DEPT ? (
        <div className={`punch-item-card punch-item ${theme.palette.mode}`}>
          <div className="left-section">
            <div className="title">{punch.description}</div>
            {valueSplit
              ?.filter((v) => v.trim().length > 0)
              .map((item, index) => (
                <div key={index} className="pill">
                  {item.trim()}
                </div>
              ))}
          </div>
          <span className="punch-item-time">{currentPunchTime}</span>
        </div>
      ) : (
        <div className={`punch-item-card punch-item-${punchTypeClass} ${theme.palette.mode}`}>
          <div>{punch.description}</div>
          <span className="punch-item-time">{currentPunchTime}</span>
        </div>
      )}
    </>
  );
};
